import apiHelper from "./apiHelper";
import { message } from "antd";

export const emailPassLogin = async (body: any) => {
  try {
    const url = "/auth/login";
    const response = await apiHelper.post(url, { ...body });

    if (response?.status !== 200) {
      message.error(response?.data?.message ?? "Something went wrong");
      console.log(response?.data?.message?.includes("Please enter OTP sent to your email"));

      if (response?.data?.message?.includes("Please enter OTP sent to your email")) {
        return { emailVerified: false };
      }
      return;
    }

    return response?.data;
  } catch (er) {
    message.error("Something went wrong");
    return;
  }
};

export const stagingLogin = async (body: any) => {
  const url = "/auth/login/staging";

  try {
    const response = await apiHelper.post(url, { ...body });
    if (response.status !== 200) {
      message.error(response.data.message);
      return;
    }
    return response.data;
  } catch {
    message.error("Something went wrong");
    return;
  }
};

export const emailPassSignup = async (body: any) => {
  const url = "/auth/signup";

  try {
    const response = await apiHelper.post(url, {
      ...body
    });
    if (response.status === 409) {
      message.error("Email already exists");
      return;
    }
    if (response.status !== 200) {
      message.error("Something went wrong");
      return;
    }
    return response;
  } catch {
    message.error("Something went wrong");
    return;
  }
};

export const verifyOTP = async (email: string, otp: number) => {
  try {
    const url = "/auth/verify";
    const response = await apiHelper.post(url, { email, otp });

    if (response.status !== 200) {
      message.error(response.data.message);
      return;
    }
    return response;
  } catch {
    message.error("Something went wrong, please try again");
    return;
  }
};

export const forgotPassword = async (email: string) => {
  const url = "/auth/forgot-password";

  try {
    const response = await apiHelper.post(url, { email });
    if (response.status !== 200) {
      message.error(response.data.message);
      return;
    }
    return response;
  } catch {
    message.error("Something went wrong, please try again");
    return;
  }
};

export const forgotPassVerifyOtp = async (email: string, otp: number) => {
  const url = "/auth/forgot-password/verify";

  try {
    const response = await apiHelper.post(url, { email, otp });
    if (response.status !== 200) {
      message.error(response.data.message ?? "Something went wrong, please try again");
      return;
    }
    return response;
  } catch {
    message.error("Something went wrong, please try again");
    return;
  }
};

export const resetPassword = async (body: any) => {
  const url = "/auth/reset-password";

  try {
    const response = await apiHelper.post(url, { ...body });
    if (response.status === 200) {
      message.success("Password reset successful");
    } else {
      message.error(response.data.message);
      return;
    }
    return response;
  } catch {
    message.error("Something went wrong, please try again");
    return;
  }
};

export const logout = async () => {
  const url = "/auth/logout";

  try {
    const response = await apiHelper.get(url, {});
    return response;
  } catch (e) {
    return false;
  }
};
